import { render, staticRenderFns } from "./WorkshopGroup.vue?vue&type=template&id=8ba0c6e0&scoped=true&"
import script from "./WorkshopGroup.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroup.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopGroup.vue?vue&type=style&index=0&id=8ba0c6e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba0c6e0",
  null
  
)

export default component.exports